<template>
    <div class="search">
        <el-input type="text" style="width:250px" :placeholder="$t('public.please_enter')" v-model="filterText" clearable></el-input>
        <el-button type="primary" icon="el-icon-search" class="btnClass" @click="searchTree"></el-button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            filterText: ''
        }
    },
    methods: {
        searchTree() { 
            this.$emit('searchTree',this.filterText)
        }
    }
}
</script>

<style lang="scss" scoped>
.search {
    width: 100%;
    height: 50px;
    padding: 10px 5px;
    border-bottom: 1px solid $borderColor3;
    box-sizing: border-box;
    display: flex;
    align-items: center;
}
</style>